import React, { useRef, useState, useCallback } from 'react';
import introVideo from '../images/Intro.mp4';

function IntroVideo({ onVideoEnd }) {
  const videoRef = useRef(null);
  const [started, setStarted] = useState(false);
  const [fadingOut, setFadingOut] = useState(false);

  const handlePlay = useCallback(() => {
    setStarted(true);
    videoRef.current?.play();
  }, []);

  const handleEnded = useCallback(() => {
    setFadingOut(true);
    setTimeout(onVideoEnd, 800);
  }, [onVideoEnd]);

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: '#000',
        zIndex: 9999,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        opacity: fadingOut ? 0 : 1,
        transition: 'opacity 0.8s ease-out',
        willChange: 'opacity',
      }}
    >
      <video
        ref={videoRef}
        src={introVideo}
        preload="auto"
        playsInline
        onEnded={handleEnded}
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          transform: 'translateZ(0)',
        }}
      />
      {!started && (
        <div
          onClick={handlePlay}
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
            background: 'rgba(0, 0, 0, 0.6)',
            transition: 'background 0.3s',
          }}
        >
          <svg
            width="80"
            height="80"
            viewBox="0 0 80 80"
            fill="none"
            style={{ filter: 'drop-shadow(0 0 10px rgba(255,255,255,0.3))' }}
          >
            <circle cx="40" cy="40" r="38" stroke="white" strokeWidth="3" fill="rgba(255,255,255,0.1)" />
            <polygon points="32,24 60,40 32,56" fill="white" />
          </svg>
        </div>
      )}
    </div>
  );
}

export default IntroVideo;
